import { application } from "./application"

import BinderController from "./binder_controller"
import EditorController from "./editor_controller"
import WorkspaceController from "./workspace_controller"

application.register("binder", BinderController)
application.register("editor", EditorController)
application.register("workspace", WorkspaceController)
